import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "../components/Layout.vue";

Vue.use(VueRouter)

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: Layout,
    redirect: '/home/index',
    meta: {
      title: '工作台',
      raking: 0,
      auth: [],
      icon: 'el-icon-s-home'
    },
    children: [
      {
        path: 'index',
        name: 'homeIndex',
        meta: {
          auth: [],
          upTitle: '首页',
          title: '工作台'
        },
        component: () => import('@/views/fwy-home/Dashboard.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录',
      hidden: true
    },
    component: () => import('@/views/fwy-login/login.vue')
  },
  {
    path: '/pay',
    name: 'pay',
    meta: {
      title: '微信中间页',
      hidden: true
    },
    component: () => import('@/views/fwy-pay/pay.vue')
  },
  {
    path: '/fwypay',
    name: 'fwypay',
    meta: {
      title: '支付页面',
      hidden: true
    },
    component: () => import('@/views/fwy-pay/fwypay.vue')
  },
  {
    path: '/xcx',
    name: 'xcx',
    meta: {
      title: '支付页面',
      hidden: true
    },
    component: () => import('@/views/fwy-pay/xcx.vue')
  },
  {
    path: '/agent',
    name: 'agent',
    meta: {
      title: '代理商管理',
      raking: 1,
      auth: ['S'],
      icon: 'el-icon-user-solid'
    },
    component: Layout,
    children: [
      {
        path: 'list',
        name: 'agentList',
        meta: {
          auth: [],
          upTitle: '代理商管理',
          title: '代理商列表'
        },
        component: () => import('@/views/fwy-agent/Index.vue')
      }
    ]
  },
  {
    path: '/mch',
    name: 'mch',
    meta: {
      title: '商户管理',
      raking: 2,
      auth: [],
      icon: 'el-icon-s-shop'
    },
    component: Layout,
    children: [
      {
        path: 'list',
        name: 'mchList',
        meta: {
          auth: [],
          upTitle: '商户管理',
          title: '商户列表'
        },
        component: () => import('@/views/fwy-mch/Index.vue')
      }
    ]
  },
  {
    path: '/incom',
    name: 'black',
    component: Layout,
    meta: {
      title: '进件管理',
      raking: 3,
      auth: [],
      icon: 'el-icon-document-add'
    },
    children: [
      {
        path: 'list',
        name: 'list',
        meta: {
          auth: [],
          title: '进件列表',
          isNew: true,
          upTitle: '进件管理',
        },
        component: () => import('@/views/fwy-incom/List.vue')
      },
      {
        path: 'add',
        name: 'add',
        meta: {
          title: '手动进件',
          upTitle: '进件管理',
          hidden: true
        },
        component: () => import('@/views/fwy-incom/AddIncom.vue')
      },
    ]
  },
  {
    path: '/order',
    name: 'order',
    component: Layout,
    meta: {
      title: '订单管理',
      raking: 4,
      auth: [],
      icon: 'el-icon-s-order'
    },
    children: [
      {
        path: 'list',
        name: 'list',
        meta: {
          auth: [],
          title: '订单列表',
          isNew: true,
          upTitle: '订单列表',
        },
        component: () => import('@/views/fwy-order/List.vue')
      }
    ]
  },
  {
    path: '/auth',
    name: 'app',
    component: Layout,
    meta: {
      title: '应用管理',
      raking: 5,
      auth: ['S'],
      icon: 'el-icon-s-platform'
    },
    children: [
      {
        path: 'list',
        name: 'list',
        meta: {
          auth: ['admin'],
          title: '应用列表',
          isNew: true,
          upTitle: '应用列表',
        },
        component: () => import('@/views/fwy-app/List.vue')
      }
    ]
  }
]
const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
})

import store from '@/store'
router.beforeEach((to, from, next) => {
  if (to.path === '/alipaysuccess' || to.path === '/login' || to.path === '/pay'|| to.path === '/fwypay'|| to.path === '/xcx') {
    next()
  }else{
    if (store.getters.token) {
      // let hidden = menus.filter(x => x.index === to.path)[0].hidden.indexOf(store.getters.userInfo.id.substring(0,1)) !== -1;
      // console.log(hidden,"-=----",to.path,store.getters.userInfo.id)
      // if (store.getters.userInfo.id.substring(0,1) == "M"){
      //     next("/order/list")
      // }else{
      next()
      // }
      // if (hidden) {
      //     next()
      // } else {
      //     next("/order/list")
      // }
    } else {
      next("/login")
    }
  }
  // }
})
export default router;
